import { http } from '@/lib/http';
import type { TaxPricingMode } from '@/types/orders';

const BASE = '/api/v1/tenancy/me/tax-settings';

export interface TaxSettings {
  taxPricingMode: TaxPricingMode;
  taxRegime: string;
  country: string;
  defaultCurrency: string;
}

export interface UpdateTaxSettingsPayload {
  taxPricingMode: TaxPricingMode;
}

export const taxSettingsService = {
  get: () => http.get<TaxSettings>(BASE),
  update: (payload: UpdateTaxSettingsPayload) =>
    http.patch<TaxSettings, UpdateTaxSettingsPayload>(BASE, payload),
};
